import template from "./sidebar.html";

const SidebarComponent = {
  bindings: {
    active: "<",
  },
  template: template,
  controller: class SidebarController {
    /* @ngInject */
    constructor($rootScope, $state) {
      this.$rootScope = $rootScope;
      this.$state = $state;
    }

    $onInit() {
      this.organization = this.$rootScope.organization;
      this.user = this.$rootScope.user;
    }

    librarySubmenuActive() {
      return this.$state.is("app.tariffsLibrary") || this.$state.is("app.costsLibrary");
    }

    goTemplatesLibrary() {
      this.$state.go("app.templateSelector");
    }

    goCostsLibrary() {
      this.$state.go("app.costsLibrary");
    }
  },
};

export default SidebarComponent;
